var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('div',{staticClass:"chip-success"},[_c('span',{style:('color:' + _vm.chipColor(_vm.params.value))},[_vm._v(_vm._s(_vm.chipText(_vm.params.value)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }